import React from "react";
import ResetConfirmForm from "../../forms/auth/ResetConfirmForm";

const ResetPasswordView = ({ initialValues, onSubmit = () => {} }) => {
  return <ResetConfirmForm onSubmit={onSubmit} initialValues={initialValues} />;
};

export default ResetPasswordView;
